import {Component, computed, inject, input, signal} from '@angular/core';
import {WineProduct} from '@core/interfaces/generated/graphql';
import {StarEmptyIconComponent} from '@core/svg-icons/star-empty-icon.component';
import {CustomerReviewsAndWishlistService} from '@core/services/customer-reviews-and-wishlist.service';
import {StarSolidIconComponent} from '@core/svg-icons/star-solid-icon.component';

@Component({
  selector: 'app-customer-rating',
  templateUrl: './customer-rating.component.html',
  styleUrls: ['./customer-rating.component.scss'],
  imports: [
    StarEmptyIconComponent,
    StarSolidIconComponent
  ]
})

export class CustomerRatingComponent {
  private customerReviewsAndWishlistService = inject(CustomerReviewsAndWishlistService);

  product = input<WineProduct | null>();
  starColor = input<string>('#ff9812');
  starHeight = input<string>('20px');
  starWidth = input<string>('20px');

  customerReviews = this.customerReviewsAndWishlistService.customerReviews;
  ratingClicked = signal(false);
  productCustomerReview = computed(() => {
    return this.customerReviews().find(review => review?.product?.id === this.product()?.id);
  });

  addReviewProduct(product: WineProduct, rating: number, removeReview: boolean = false) {
    this.ratingClicked.set(true);
    this.customerReviewsAndWishlistService.addReviewProduct(product, rating, removeReview);

    setTimeout(() => {
      this.ratingClicked.set(false);
    }, 600);
  }
}
